import React, { Component } from 'react';
import StatTile from './StatTile/StatTile';
import './StatsRow.css';

class StatsRow extends Component {
	render(){
		let c = this.props.company;
		// placeholders in case of no data
		let placeHolderStat = 'N/A';
		return(
			<div className="stats-row-container">
			<StatTile stat={c.gearing_ratio ? c.gearing_ratio : placeHolderStat} label='gearing ratio' textColor="#666666" bgColor="#CBCBCB"/>
			<StatTile stat={c.ebitmargin ? c.ebitmargin : placeHolderStat} label='ebit margin' textColor="#2963FB" bgColor="#BAD8FF"/>
			<StatTile stat={c.liabilities_ratio ? c.liabilities_ratio : placeHolderStat} label='liabilities ratio' textColor="#41D4CF" bgColor="#CAFDFC"/>
			</div>
			)
	}
}

export default StatsRow;


// WEBPACK FOOTER //
// ./src/components/CompanyResults/StatsRow/StatsRow.js